/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ChatsCircle(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M230.53955,189.7666A80.01439,80.01439,0,0,0,169.56543,72.58691a80.00141,80.00141,0,1,0-144.105,69.17969l-6.18457,21.6499a13.99955,13.99955,0,0,0,17.30566,17.30909l21.65235-6.186a79.84121,79.84121,0,0,0,28.18994,8.88367,80.03721,80.03721,0,0,0,111.34326,39.11584l21.65137,6.18653A14.00007,14.00007,0,0,0,236.7251,211.418Zm-15.4873-5.10791a8.00114,8.00114,0,0,0-.81641,6.28711l6.11621,21.40625-21.40625-6.11572a8.00193,8.00193,0,0,0-6.28613.8164,64.03376,64.03376,0,0,1-88.33985-23.48608,79.90524,79.90524,0,0,0,70.37549-93.85889,64.02222,64.02222,0,0,1,40.35694,94.95093Z" />
    </Svg>
  );
}

export default ChatsCircle;
